"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEYS_TO_ENCRYPT = exports.DEFAULT_OPTIONS = void 0;
exports.DEFAULT_OPTIONS = {
    // Avoid adding pid and hostname properties to each log.
    base: undefined,
    level: 'info'
};
exports.KEYS_TO_ENCRYPT = [
    'FIRSTNAME',
    'LASTNAME',
    'SURNAME',
    'EMAIL',
    'EMAILADDRESS',
    'PHONENUMBER',
    'PIN',
    'PASSWORD',
    'SERVICEPHONENUM',
    'MOBILEPHONE',
    'DRIVERLICENSENUM',
    'DRIVERSLICENSENUMBER',
    'PASSPORTNUMBER',
    'SIN',
    'PASSPORTNUM',
    'SINNUM',
    'SERVICEADDRESS',
    'SHIPPINGADDRESS',
    'BILLINGADDRESS',
    'CREDITADDRESS',
    'CANADAPOSTRESPONSE',
    'BIRTHDATE',
    'CREDITCARD',
    'CARD',
    'CCEXPDATE',
    'CCNUMBER',
    'CCTYPE',
    'CCNAME',
    'CARDDETAILS',
    'CARDISSUER',
    'PAYERREF',
    'PAYMENTREF',
    'PAYMENTMETHOD',
    'SESSIONTOKEN',
    'OAUTH2TOKEN',
    'TSESSIONTOKEN',
    'ACCESSTOKEN',
    'TOAUTH2TOKEN',
    'XAUTHORIZATION',
    'AUTHORIZATION',
    'ADDRESS',
    'SDATA'
];
